import React from "react";
import StatCard from "../components/dashboard/StatCard";
import FilterBar from "../components/dashboard/FilterBar";
import AssessmentTable from "../components/dashboard/AssessmentTable";
import { MdRefresh } from "react-icons/md";
import {
  IconBarChart,
  IconPencil,
  IconClock,
  IconRefresh,
  IconCheckCircle,
} from "../components/shared/Icons";

const DashboardPage = ({
  counts,
  filteredRecords,
  activeFilter,
  searchQuery,
  typeFilter,
  setActiveFilter,
  setSearchQuery,
  setTypeFilter,
  onNewForm,
  onEdit,
  loadingRecords,   // ← NEW
}) => (
  <div
    style={{
      margin: "0 auto",
      width: "90%",
      padding: "0 28px 60px",
      fontFamily: "'Segoe UI', Arial, sans-serif",
    }}
  >
    {/* Track your progress banner */}
    <div
      style={{
        background: "#f3e5f5",
        borderLeft: "4px solid #bb1ccc",
        padding: "12px 18px",
        margin: "24px 0 20px",
        borderRadius: "0 8px 8px 0",
        fontSize: "13px",
        color: "#333",
      }}
    >
      <span style={{ fontWeight: "bold", color: "#bb1ccc" }}>
        Track Your Progress&nbsp;&nbsp;
      </span>
      Mark any Reviewed assessment as complete to create a workflow. View all
      your workflows in the Transition Dashboard
    </div>

    {/* Page title row */}
    <div
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        marginBottom: "24px",
      }}
    >
      <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
        <div>
          <h1 style={{ margin: 0, fontSize: "22px", fontWeight: "700", color: "#111" }}>
            Maturity Assessments
          </h1>
          <p style={{ margin: 0, fontSize: "13px", color: "#888" }}>
            Track and manage solution maturity assessments
          </p>
        </div>
      </div>

      <div style={{ display: "flex", gap: "12px" }}>
        <button
          onClick={onNewForm}
          style={{
            background: "#bb1ccc",
            color: "white",
            border: "none",
            borderRadius: "8px",
            padding: "10px 22px",
            fontWeight: "600",
            fontSize: "14px",
            cursor: "pointer",
          }}
        >
          + New Form
        </button>
        <button
          style={{
            background: "#9ca3af",
            color: "white",
            border: "none",
            borderRadius: "8px",
            padding: "10px 22px",
            fontWeight: "600",
            fontSize: "14px",
            cursor: "not-allowed",
          }}
        >
          ✓ Mark Complete (0)
        </button>
      </div>
    </div>

    {/* Stat cards */}
    <div style={{ display: "flex", gap: "14px", marginBottom: "28px", flexWrap: "wrap" }}>
      <StatCard label="Total"     count={counts.All}       icon={<IconBarChart />} />
      <StatCard label="Drafted"   count={counts.Draft}     icon={<IconPencil color="#888" />} />
      <StatCard label="Submitted" count={counts.Submitted} icon={<IconClock color="#f59e0b" />} />
      <StatCard label="Feedback"  count={counts.Feedback}  icon={<MdRefresh size={25} color="#3b82f6" />} />
      <StatCard label="Reviewed"  count={counts.Reviewed}  icon={<IconCheckCircle color="#22c55e" />} />
    </div>

    {/* Filter bar */}
    <FilterBar
      searchQuery={searchQuery}
      onSearchChange={setSearchQuery}
      activeFilter={activeFilter}
      onFilterChange={setActiveFilter}
      counts={counts}
      typeFilter={typeFilter}
      onTypeChange={setTypeFilter}
    />

    {/* Records table — pass loading so skeleton shows while API fetches */}
    <AssessmentTable
      records={filteredRecords}
      onEdit={onEdit}
      loading={loadingRecords}   // ← NEW
    />
  </div>
);

export default DashboardPage;